  $('.custom-submit').click(function(){
      if($("#contact_form #first-name").val() == ''){
      $('#contact_form').find('#first-name').parent().find('.agreement_required_info').remove();
      $("#contact_form #first-name").focus();
       $("#contact_form #first-name").css("border-bottom", "1px solid red");
       $('#contact_form').find('#first-name').parent().append("<p class='agreement_required_info'>This field is required</p>");
          return false;
        }else{
      $("#contact_form #first-name").css("border-bottom", "1px solid #ccc");
      $('#contact_form').find('#first-name').parent().find('.agreement_required_info').remove();
      }

      if($("#contact_form #last-name").val() == ''){
      $('#contact_form').find('#last-name').parent().find('.agreement_required_info').remove();
      $("#contact_form #last-name").focus();
       $("#contact_form #last-name").css("border-bottom", "1px solid red");
       $('#contact_form').find('#last-name').parent().append("<p class='agreement_required_info'>This field is required</p>");
          return false;
        }else{
      $("#contact_form #last-name").css("border-bottom", "1px solid #ccc");
      $('#contact_form').find('#last-name').parent().find('.agreement_required_info').remove();
      }

        if($("#contact_form #email").val() == ''){
      $('#contact_form').find('#email').parent().find('.agreement_required_info').remove();
      $("#contact_form #email").focus();
       $("#contact_form #email").css("border-bottom", "1px solid red");
       $('#contact_form').find('#email').parent().append("<p class='agreement_required_info'>This field is required</p>");
          return false;
        }else{
      $("#contact_form #email").css("border-bottom", "1px solid #ccc");
      $('#contact_form').find('#email').parent().find('.agreement_required_info').remove();
      }

         if($("#contact_form #phone").val() == ''){
      $('#contact_form').find('#phone').parent().find('.agreement_required_info').remove();
      $("#contact_form #phone").focus();
       $("#contact_form #phone").css("border-bottom", "1px solid red");
       $('#contact_form').find('#phone').parent().append("<p class='agreement_required_info'>This field is required</p>");
          return false;
        }else{
      $("#contact_form #phone").css("border-bottom", "1px solid #ccc");
      $('#contact_form').find('#phone').parent().find('.agreement_required_info').remove();
      }

        if($("#contact_form #Inquiry").val() == ''){
      $('#contact_form').find('#Inquiry').parent().find('.agreement_required_info').remove();
      $("#contact_form #Inquiry").focus();
       $("#contact_form #Inquiry").css("border-bottom", "1px solid red");
       $('#contact_form').find('#Inquiry').parent().append("<p class='agreement_required_info'>This field is required</p>");
          return false;
        }else{
      $("#contact_form #Inquiry").css("border-bottom", "1px solid #ccc");
      $('#contact_form').find('#Inquiry').parent().find('.agreement_required_info').remove();
      }

      if ($('#accept_terms_policy').is(':checked')) {
               
               }
                else {
                    alert('please check terms & conditions')
                }
   
        });